"use strict";

var _interopRequireDefault = require("/var/www/html/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.regexp.replace");
var _echarts = _interopRequireDefault(require("echarts"));
//
//
//
//
//
var _default2 = exports.default = {
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      chart: null,
      colors: ['#2563EB', '#2F7BEA', '#3B8FE8', '#4BA3E6', '#5CB8E4', '#5FC6D8', '#4AB89A', '#3AA37E']
    };
  },
  computed: {
    chartData: function chartData() {
      var _this = this;
      return this.list.map(function (item, index) {
        return {
          name: item.title,
          value: _this.parsePercent(item.baseRate),
          count: item.count,
          baseRate: item.baseRate,
          upperRate: item.upperRate,
          desc: item.desc,
          itemStyle: {
            color: _this.colors[index] || _this.colors[_this.colors.length - 1]
          }
        };
      });
    }
  },
  watch: {
    chartData: function chartData() {
      if (this.chart) {
        this.setOption();
      }
    }
  },
  mounted: function mounted() {
    this.initChart();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    if (this.chart) {
      this.chart.dispose();
      this.chart = null;
    }
  },
  methods: {
    parsePercent: function parsePercent(percent) {
      return parseFloat(String(percent).replace('%', '')) || 0;
    },
    initChart: function initChart() {
      this.chart = _echarts.default.init(this.$refs.chart);
      this.setOption();
      this.chart.on('click', this.handleChartClick);
    },
    handleChartClick: function handleChartClick(params) {
      var index = params.dataIndex;
      var item = this.list[index];
      this.$emit('item-click', item, index);
    },
    setOption: function setOption() {
      var option = {
        tooltip: {
          trigger: 'item',
          formatter: function formatter(params) {
            var data = params.data;
            return "\n                            <div style=\"font-weight:500;\">\n                                ".concat(data.name, "\n                                <span style=\"font-size: 12px;\">(").concat(data.desc, ")</span>\n                            </div>\n                            <div>\u8BA2\u5355\u6570\uFF1A").concat(data.count, "</div>\n                            <div>\u57FA\u51C6\u5360\u6BD4\uFF1A").concat(data.baseRate, "</div>\n                            <div>\u8F83\u4E0A\u4E00\u5C42\uFF1A").concat(data.upperRate, "</div>\n                        ");
          }
        },
        series: [{
          name: '漏斗图',
          type: 'funnel',
          left: '10%',
          top: 20,
          bottom: 20,
          width: '80%',
          min: 0,
          max: 100,
          minSize: '20%',
          maxSize: '100%',
          sort: 'none',
          gap: 1,
          label: {
            show: true,
            position: 'inside',
            formatter: function formatter(params) {
              var data = params.data;
              return "{title|".concat(data.name, "}\n{baseRate|").concat(data.baseRate, "}");
            },
            rich: {
              title: {
                fontSize: 14,
                fontWeight: 500,
                color: '#fff',
                lineHeight: 20
              },
              baseRate: {
                fontSize: 18,
                fontWeight: 600,
                color: '#fff',
                lineHeight: 24
              }
            }
          },
          labelLine: {
            show: false
          },
          itemStyle: {
            borderColor: '#fff',
            borderWidth: 0
          },
          emphasis: {
            label: {
              fontSize: 16
            }
          },
          data: this.chartData
        }]
      };
      this.chart.setOption(option, true);
    },
    handleResize: function handleResize() {
      if (this.chart) {
        this.chart.resize();
      }
    }
  }
};